import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import ClientSidebar from '../components/ClientSidebar';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Therapists from '../components/Therapists';
import Footer from '../components/Footer';
import ChatBotTrigger from '../../components/ChatBotTrigger';

const getStoredClientUser = () => {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return (parsed?.role || '').toLowerCase() === 'client' ? parsed : null;
  } catch {
    return null;
  }
};

const ClientHome = () => {
  const [clientUser, setClientUser] = useState(() => getStoredClientUser());
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const onStorage = () => setClientUser(getStoredClientUser());
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  useEffect(() => {
    const onScroll = () => setShowScrollTop(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const sections = (
    <div className="transition-all duration-300">
      <section id="home"><Hero /></section>
      <section id="services"><Services /></section>
      <section id="therapists"><Therapists /></section>
      <section id="contact"><Footer /></section>
    </div>
  );

  return (
    <div className="scroll-smooth bg-[#F5F2ED] text-[#2D2D2D] font-sans">
      <Navbar
        clientUser={clientUser}
        onAuthChange={setClientUser}
        isSidebarOpen={isSidebarOpen}
        onMenuOpen={setIsSidebarOpen}
      />

      {clientUser ? (
        <div>
          <ClientSidebar
            isOpen={isSidebarOpen}
            onOpenChange={setIsSidebarOpen}
            clientName={clientUser?.full_name}
            clientEmail={clientUser?.email}
            clientAvatar={clientUser?.avatar_url}
            showTrigger={false}
            onLogout={() => {
              setClientUser(null);
              setIsSidebarOpen(false);
            }}
          />
          {sections}
        </div>
      ) : sections}

      {/* Scroll-to-top button */}
      <button
        onClick={scrollToTop}
        aria-label="Scroll to top"
        className={`fixed bottom-6 right-6 z-50 w-11 h-11 rounded-full bg-[#1c0f07] text-white shadow-lg flex items-center justify-center transition-all duration-300 hover:bg-[#8b5e3c] ${
          showScrollTop ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 15l7-7 7 7"/>
        </svg>
      </button>
      <ChatBotTrigger />
    </div>
  );
};

export default ClientHome;